import { ProductModel } from '@models/ProductModel';
import { VendorBasicModel, VendorStoreModel } from '@models/VendorModel';
import { GiftcardModel } from '@shared/models/GiftcardModel';
import { TicketModel } from '@models/TicketModel';
import { CategoryModel, ThematicModel, ZoneModel } from '@models/CategoryModel';
import { CashlessModel } from './models/EventModel';
import { CommunityModel } from './models/CommunityModel';


const communities: CommunityModel[] = [];

const vendors: VendorBasicModel[] = [];

const giftcards: GiftcardModel[] = [];

const tickets: TicketModel[] = [];

const cashless: CashlessModel[] = [];

const products: ProductModel[] = [];

const stores: VendorStoreModel[] = [];

const categories: CategoryModel[] = [];

const thematics: ThematicModel[] = [];

const zones: ZoneModel[] = [];

const envVariables: any = {};

const eventSearchHistory: any = [];
const eventFilterHistory: any = {};

const lastNavigation: any = {};

export {
    categories,
    thematics,
    zones,
    vendors,
    communities,
    giftcards,
    tickets,
    cashless,
    products,
    stores,
    envVariables,

    eventSearchHistory,
    eventFilterHistory,

    lastNavigation
};
